import React from 'react';
import { Link } from 'react-router-dom';

export default function TermosUso() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-acre-dark to-[#1a4a2e] flex items-start justify-center p-4 py-10">
      <div className="w-full max-w-2xl">
        {/* Logo */}
        <div className="text-center mb-6">
          <Link to="/" className="inline-flex items-center gap-2">
            <span className="text-2xl">🌿</span>
            <span className="font-sora font-bold text-2xl text-white">Acre<span className="text-acre-gold">Job</span></span>
          </Link>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h1 className="font-sora font-bold text-2xl text-acre-dark mb-1">Termos de Uso</h1>
          <p className="text-xs text-gray-400 mb-6">Última atualização: 28/05/2026</p>

          <div className="prose prose-sm max-w-none text-gray-700 space-y-6">

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">1. Aceitação dos termos</h2>
              <p className="text-sm">
                Ao acessar ou utilizar a plataforma AcreJob, você declara ter lido, compreendido e concordado com estes Termos de Uso, bem como com nossa Política de Privacidade. Se você não concordar com qualquer disposição destes termos, não deverá utilizar nossos serviços.
              </p>
              <p className="text-sm mt-2">
                A AcreJob reserva-se o direito de atualizar estes termos a qualquer momento. As alterações entram em vigor na data de publicação, e o uso continuado da plataforma após essa data configura aceitação das novas condições.
              </p>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">2. Cadastro e conta</h2>
              <p className="text-sm">Para utilizar os recursos da AcreJob, você deve:</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li>Fornecer informações verdadeiras, precisas e atualizadas no momento do cadastro.</li>
                <li>Manter a confidencialidade de sua senha e não compartilhá-la com terceiros.</li>
                <li>Notificar imediatamente a AcreJob sobre qualquer uso não autorizado de sua conta.</li>
                <li>Ser responsável por todas as atividades realizadas em sua conta.</li>
              </ul>
              <p className="text-sm mt-2">
                É vedado criar mais de uma conta por pessoa física ou jurídica sem autorização prévia da AcreJob.
              </p>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">3. Uso da plataforma</h2>
              <p className="text-sm">Ao utilizar a AcreJob, você concorda em:</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li>Usar a plataforma apenas para fins legítimos de recrutamento e busca de emprego.</li>
                <li>Não publicar conteúdo ofensivo, discriminatório, ilegal ou enganoso.</li>
                <li>Não tentar acessar áreas restritas ou sistemas não autorizados.</li>
                <li>Não utilizar robôs, scrapers ou qualquer meio automatizado sem autorização escrita.</li>
                <li>Respeitar os direitos de propriedade intelectual da AcreJob e de terceiros.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">4. Candidatos</h2>
              <p className="text-sm">Os candidatos cadastrados na plataforma:</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li>Podem criar e manter um perfil profissional gratuito com currículo, foto e vídeo de apresentação.</li>
                <li>Autorizam a AcreJob a exibir seu perfil profissional para empresas cadastradas na plataforma.</li>
                <li>São responsáveis pela veracidade das informações incluídas no currículo.</li>
                <li>Podem gerenciar a visibilidade do seu perfil a qualquer momento pelas configurações da conta.</li>
                <li>Reconhecem que a AcreJob não garante a obtenção de emprego.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">5. Empresas</h2>
              <p className="text-sm">As empresas cadastradas na plataforma:</p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li>Devem efetuar o pagamento do plano correspondente para acessar os recursos de recrutamento.</li>
                <li>São responsáveis pela veracidade e legalidade das vagas publicadas.</li>
                <li>Comprometem-se a cumprir a legislação trabalhista brasileira vigente em seus processos seletivos.</li>
                <li>Não podem utilizar os dados dos candidatos para finalidades diferentes do recrutamento.</li>
                <li>Reconhecem que a AcreJob não é parte nas relações de trabalho entre empresa e candidato.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">6. Pagamentos</h2>
              <p className="text-sm">
                O cadastro na plataforma AcreJob é gratuito para todos os usuários. O acesso às funcionalidades de recrutamento para empresas requer a contratação de um plano pago. As seguintes condições se aplicam:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li><strong>Planos disponíveis:</strong> 30 dias, 60 dias ou 90 dias de acesso completo à plataforma.</li>
                <li><strong>Formas de pagamento:</strong> PIX (com 10% de desconto) ou Cartão de Crédito (Visa ou Mastercard, em até 3x).</li>
                <li><strong>Gateway de pagamento:</strong> as transações são processadas pela <strong>Pagar.me</strong>, plataforma certificada PCI DSS. Dados de cartão não são armazenados nos servidores da AcreJob.</li>
                <li><strong>Liberação automática:</strong> pagamentos via PIX e Cartão de Crédito aprovados pelo gateway são liberados automaticamente, sem necessidade de aprovação manual.</li>
                <li><strong>Pagamento manual:</strong> quando o gateway não estiver disponível, o acesso é liberado após análise do comprovante enviado pelo usuário, em até 1 dia útil.</li>
                <li><strong>Candidatos:</strong> têm acesso gratuito e ilimitado à plataforma para busca de vagas e gerenciamento do perfil profissional.</li>
                <li>Não há reembolso após a liberação do acesso, salvo em casos de erro comprovado da plataforma.</li>
                <li>O acesso expira automaticamente ao término do período contratado.</li>
                <li>Os preços podem ser alterados com aviso prévio de 30 dias.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">7. Propriedade intelectual</h2>
              <p className="text-sm">
                Todo o conteúdo da plataforma AcreJob — incluindo logotipos, textos, layouts, código-fonte, design e funcionalidades — é de propriedade exclusiva da AcreJob ou de seus licenciadores, protegido pelas leis brasileiras e internacionais de propriedade intelectual.
              </p>
              <p className="text-sm mt-2">
                O usuário concede à AcreJob uma licença não exclusiva, gratuita e mundial para exibir e utilizar o conteúdo que ele submeter à plataforma (como currículo, foto e vídeo) para os fins previstos nestes termos.
              </p>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">8. Limitação de responsabilidade</h2>
              <p className="text-sm">
                A AcreJob atua como intermediária tecnológica entre candidatos e empresas. Não somos responsáveis por:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li>Contratações, recusas, demissões ou quaisquer decisões tomadas pelas empresas.</li>
                <li>Veracidade das informações fornecidas por usuários (candidatos ou empresas).</li>
                <li>Perdas indiretas, lucros cessantes ou danos consequenciais decorrentes do uso da plataforma.</li>
                <li>Interrupções temporárias do serviço por manutenção ou causas técnicas alheias ao nosso controle.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">9. Rescisão</h2>
              <p className="text-sm">
                A AcreJob pode suspender ou encerrar sua conta, sem aviso prévio, nos seguintes casos:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                <li>Violação destes Termos de Uso ou da Política de Privacidade.</li>
                <li>Fraude, atividade ilegal ou uso inadequado da plataforma.</li>
                <li>Inadimplência no pagamento do plano contratado.</li>
              </ul>
              <p className="text-sm mt-2">
                O usuário pode encerrar sua conta a qualquer momento através das configurações do perfil. Após o encerramento, os dados serão retidos pelo prazo mínimo exigido pela legislação aplicável.
              </p>
            </section>

            <section>
              <h2 className="font-sora font-semibold text-base text-acre-dark mb-2">10. Disposições gerais</h2>
              <p className="text-sm">
                Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca de Rio Branco — Acre para dirimir quaisquer controvérsias decorrentes deste instrumento, com exclusão de qualquer outro, por mais privilegiado que seja.
              </p>
              <p className="text-sm mt-2">
                Caso qualquer disposição destes termos seja considerada inválida ou inaplicável, as demais disposições permanecerão em pleno vigor e efeito.
              </p>
              <p className="text-sm mt-2">
                Dúvidas ou solicitações relacionadas a estes termos podem ser enviadas para <a href="mailto:contato@acrejob.com.br" className="text-acre-green hover:underline font-medium">contato@acrejob.com.br</a>.
              </p>
            </section>

          </div>
        </div>

        <p className="text-center text-white/40 text-xs mt-5">
          <Link to="/" className="hover:text-white/70">← Voltar ao início</Link>
        </p>
      </div>
    </div>
  );
}
